// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import * as angular from 'angular';
import { SESSION_ID } from '../../../../config/session-id';
import { ua } from '../../../../util/user-agent';
import { Captcha } from '../../../components/captcha/captcha.model';

/** @ngInject */
export function Controller(
    $rootScope,
    $scope,
    $state,
    $timeout,
    AuthenticationSharedService,
    BarcodeGeneratonService,
    HardTokenLoginModal,
    SamlLoginHandler,
    SamlService
) {
    const vm = $scope.vm = {};
    $scope.loginPasswordModeF = (m) => $scope.loginPasswordMode=m;
    $scope.rememberMe = false;
    $scope.loginPassword = false;
    var appKey = $scope.appData =  $state.params.applicationId;
    $scope.icon = $state.params.icon;
    $scope.appName = $state.params.appName;
    $scope.samlTracker= $state.params.SAMLTracker;
    $scope.loginPasswordModeF($state.params.loginWithPassword);
    let sendingPushLoginNotification = false;
    var appType = $scope.appType = $state.params.appType;
    var icon = $state.params.icon;
    $scope.appAccountFormat= 'USERNAME_AND_EMAIL';
    vm.passwordManual='';
    //$scope.infoSamlMsg = "Logging in. Please wait...";
    SamlService.getAppAccountFormat.get({
        appKey : appKey
    }, function(data){
        $scope.isReady = true;
        $scope.appAccountFormat=data.accountFormat;
        $scope.pwdAuthenticationEnabled = data.pwdAuthenticationEnabled;
        $scope.pwdAuthenticationOnSaaspass = data.pwdAuthenticationOnSaaspass;
        $scope.ilEnabled = data.ilEnabled;
        $scope.plEnabled = data.plEnabled;
        if ($scope.pwdAuthenticationEnabled) {
        	if (appType==='google-apps'){
                if ($scope.pwdAuthenticationOnSaaspass === true) {
                    $rootScope.passwordMode = $scope.passwordMode = false;
                    $scope.loginPassword = true;
                } else {
                    $rootScope.passwordMode = $scope.passwordMode = true;
                    $scope.loginPassword = false;
                }
            } else {
            	 $scope.loginPassword = true;
            }
        } 
    }, function(error){
        $scope.isReady = true;
    });

    
    if(icon){        
        $scope.samlImage = `${window.env.urls.premiumIconPrefix}${icon}`;
    }else{
        $scope.samlImage = window.env.urls.samlAppLogo(appType);
    }
    	
    const captcha = $scope.captcha = new Captcha();

    

    $scope.loadQrData = () => {
        return BarcodeGeneratonService
            .applicationBarcode({uuid: SESSION_ID, appKey}).$promise
            .then((barcode) => {
                $scope.mobileLoginUrl = `saaspass-wa://login?barcode=${barcode.bluetoothcode}`;
                $scope.bluetoothCode = barcode.bluetoothcode;
                return barcode.barcodeimage;
            })
            .catch((response) => {
                if (response.status === 400) {
                    $state.go('public.custom-error',{error_message:response.data.message})
                }
            });
    };
    
    var usernameStorage = localStorage.getItem("saml_username_" + appKey );
    var saaspassIdStorage = localStorage.getItem("saml_saaspassId" + appKey );
    if(usernameStorage != null && angular.isDefined(usernameStorage)){
        $scope.rememberMe = true;
        $scope.username = angular.copy(usernameStorage);     
        if(saaspassIdStorage != null && angular.isDefined(saaspassIdStorage)){
            $scope.saaspassId = saaspassIdStorage;
        }
        if (captcha.isValid()) {
                pushLogin(usernameStorage);
        }
    }
    
    $scope.$on('websocket.SAML_LOGIN', (event, data) => {
        SamlLoginHandler.login(data.username, data.password, true, false);
    });

    $scope.$on('websocket.LOGIN_REJECTED', (event, data) => {
        $('#pushLoginModal').modal('hide');
    });

    var samlSaaspassIdTemp = null;
    function onPushLoginSuccess(username) {
        vm.pushLoginPopoverIsOpen = true;
        $timeout(2000).then(() => vm.pushLoginPopoverIsOpen = false);
        if($scope.rememberMe){    
            localStorage.setItem("saml_username_" + appKey, username);
            if(samlSaaspassIdTemp){
                localStorage.setItem("saml_saaspassId_" + appKey, samlSaaspassIdTemp);
            }
        }
        var pushLoginModal = $('#pushLoginModal');
        if(pushLoginModal.is(':visible')){
            pushLoginModal.modal('hide');
        }    
    }
    
    function onPushLoginError(code) {
       if(code == "ERR_101203"){
           $rootScope.authenticationError = false;
           $("#pushLoginModal").modal();
           const loginAttempts = +localStorage.getItem('loginAttempts') || 0;
           localStorage.setItem('loginAttempts', loginAttempts - 1);
       }else if(code == "ERR_100701"){
           $("#pushLoginModal").modal('hide');
       }
    }
        
    $scope.pushLogin = pushLogin;
    function pushLogin(username) {
        if(!username){
            username = $scope.username;
        }        
        
        sendingPushLoginNotification = true;
        AuthenticationSharedService
            .sendPushLoginNotification(captcha.response, username, null, appKey, $scope.saaspassId)
            .then(onPushLoginSuccess)
            .catch(onPushLoginError)
            .finally(() => {
                captcha.reset();
                sendingPushLoginNotification = false;
            });
        samlSaaspassIdTemp = angular.copy($scope.saaspassId);
        $scope.saaspassId = null;
    }
    
    $scope.rememberMeChanged = function () {
        if(!$scope.rememberMe){            
            localStorage.removeItem("saml_username_" + appKey);
            localStorage.removeItem("saml_saaspassId_" + appKey);
        }
    }      
    
    $scope.pulssing = "";
    
    $scope.pulse = function() {            
            $scope.pulssing = "pulseAnimate";
            $("html, body").animate({ scrollTop: $(document).height() }, 2000);

            $timeout(function() {
                $scope.pulssing = "";
            }, 2000);
    };
    
    $scope.login = function () {
        $rootScope.captchaError = false;
        $rootScope.authenticationError = false;
        if (!$scope.loginPasswordMode){
            SamlLoginHandler.login($scope.username, vm.otpPassword, false, false, captcha.response, errorCallback)
        }
        else{
            SamlLoginHandler.login($scope.username, vm.passwordManual, false, true, captcha.response, errorCallback)
        }
    };
    $scope.oldLogin = function () {
        $rootScope.captchaError = false;
        $rootScope.authenticationError = false;
        SamlLoginHandler.login($scope.username, $scope.password, false, true, captcha.response, errorCallback);
    };
    
    $scope.newLoginButton = ua.isAndroid() || ua.isIOS();
   
    // error callback function on login
    var errorCallback = function(response){
        var status = response.status;
        if (status == 412) {            
            $rootScope.captchaError = true;     
            $rootScope.captchaErrorMsg = 'login.messages.error.invalid_captcha';
        } else {
            $rootScope.authenticationError = true;
        }
        captcha.reset();
    };

    $scope.pushLoginDisabled = pushLoginDisabled;

    function pushLoginDisabled() {
        return !$scope.username
            || sendingPushLoginNotification
            || vm.pushLoginPopoverIsOpen
            || !captcha.isValid();
    }

    $scope.showHardTokenLoginModal = () => HardTokenLoginModal();
}



// WEBPACK FOOTER //
// ./src/portal/states/public/login-web-saml/login-web-saml.controller.js